module.exports = __webpack_public_path__ + "img/2007-08_the-new-york-times.b67cc31d.png";